import React, { useEffect, useState } from "react";
import { Step, Steps, useSteps } from "chakra-ui-steps";
import { Box, Heading } from "@chakra-ui/react";

const EmailApprovalProgress = ({ status }) => {
  const { nextStep, prevStep, setStep, reset, activeStep } = useSteps({
    initialStep: 0,
  });
  const [state, setState] = useState("");

  const steps = [
    { label: "Email sent for approval" },
    { label: "Waiting approval" },
    { label: "Approved" },
  ];
  const stepsWithQueue = [
    { label: "Email sent for approval" },
    { label: "Waiting approval" },
    { label: "Approved" },
    { label: "Queued" },
  ];

  useEffect(() => {
    initialStepAndState(status);
  }, [status]);

  const initialStepAndState = (status) => {
    if (status === "PENDING") {
      setStep(1);
      setState("loading");
    } else if (status === "SUCCEEDED") {
      setStep(3);
      setState("");
    } else if (status === "QUEUED") {
      setStep(4);
      setState("");
    }
    console.log(status);
    console.log(state);
  };

  return (
    <Box>
      <Heading as="h4" size="md" mb="4">
        Email Approval
      </Heading>
      {status === "QUEUED" ? (
        <Steps colorScheme="teal" activeStep={activeStep}>
          {stepsWithQueue.map(({ label }) => (
            <Step label={label} key={label} state={state}></Step>
          ))}
        </Steps>
      ) : (
        <Steps colorScheme="teal" activeStep={activeStep}>
          {steps.map(({ label }) => (
            <Step label={label} key={label} state={state}></Step>
          ))}
        </Steps>
      )}
    </Box>
  );
};

export default EmailApprovalProgress;
